module.exports = __webpack_public_path__ + "static/media/ibec.8429e793.png";